import React from 'react';
import SelectLeaveRequestPage from './SelectLeaveRequestPage';

const SelectLeaveRequestPageWrapper = () => {
  return <SelectLeaveRequestPage />;
};

export default SelectLeaveRequestPageWrapper;
